import React from 'react';
import CategoryHotfilterHeader from './category-hotfilter-header/category-hotfilter-header';
import styles from './catalog-category-hotfilter.module.scss';
import CategoryMenuList from './category-menu-list/category-menu-list';

const CatalogCategoryHotfilter = () => {
  return (
    <div className={styles.catalogCategoryHotfilter__wrapper}>
      <CategoryHotfilterHeader />
      <div className={styles.catalogCategoryHotfilter__scrollContainer}>
        <CategoryMenuList />
      </div>
    </div>
  );
};

export default CatalogCategoryHotfilter;
